import GlobalConfig from "./components/GlobalConfig";

export default GlobalConfig;
